
// Import components
import About from '../../components/About';
import Contact from '../../components/Contact';
import Doctors from '../../components/Doctors';
import Footer from '../../components/Footer';
import HeroSection from '../../components/HeroSection';
import Navbar from '../../components/Navbar';
import PrivacyModal from '../../components/PrivacyModal';
import Services from '../../components/Services';
import WhatsApp from '../../components/WhatsApp';

// Import custom hook
import { usePrivacyConsent } from '../../hooks/usePrivacyConsent';

/**
 * Componente principal de la página de inicio
 */
const Home = () => {
  // Hook para manejo del consentimiento de privacidad
  const {
    hasConsent,
    showModal,
    setShowModal,
    acceptConsent,
    rejectConsent,
    requireConsent
  } = usePrivacyConsent();

  return (
    <div className="w-full min-h-screen relative">
      <Navbar />
      {/* Todo en una sola página con navegación moderna */}
      <div id="hero" className="w-full">
        <HeroSection />
      </div>
      <div id="about" className="w-full">
        <About />
      </div>
      <div id="doctors" className="w-full">
        <Doctors />
      </div>
      <div id="services" className="w-full">
        <Services />
      </div>
      <div id="contact" className="w-full">
        <Contact hasConsent={hasConsent} onRequireConsent={requireConsent} />
      </div>
      <Footer />
      <WhatsApp />

      {/* Modal de Privacidad */}
      <PrivacyModal
        isOpen={showModal}
        onAccept={acceptConsent}
        onReject={rejectConsent}
        onClose={() => setShowModal(false)}
      />
    </div>
  );
};

export default Home;
